<div>{{label}}</div>
<div class="input-group"
     [class.has-error]="hasError">
  <span class="input-group-addon">
    <i class="fa fa-search"></i>
  </span>
  <ng-content></ng-content>
</div>